import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLBoolean,
  GraphQLID,
  GraphQLList
} from 'graphql'

export interface FeatureFlag {
  readonly id: string
  readonly active: boolean
}

export const featureFlag = new GraphQLObjectType({
  name: 'FeatureFlag',
  fields: () => ({
    id: {
      description: 'The unique ID for a feature flag',
      type: new GraphQLNonNull(GraphQLID)
    },
    active: {
      description: 'Indicates if the feature flag is active or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

export const featureFlags = new GraphQLObjectType({
  name: 'FeatureFlags',
  fields: () => ({
    items: {
      type: new GraphQLList(featureFlag)
    }
  })
})
